import React from 'react';
import '../App.css'

export default function Footer(props) {
    return (
        <div className={props.className}><a>Privacy</a><a>Terms of Service</a></div>
    )
}
